import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SITE_SURVEYS_GROUPED_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('SITE_SURVEYS_GROUPED');
export const SITE_SURVEYS_GROUPED_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SITE_SURVEYS_GROUPED_CRUD_ACTION_CONSTANTS
);
